export default function createVideoContentStyle({ videoHeight }) {
  return {
    height: videoHeight,
    width: '100%'
  };
}
